const workflowDefinitions = [
  ["requestAccess", "request-access", "REQUEST CLASS ACCESS", "requestAccess"],
  ["requestAccessOtherTeacher", "request-access-other-teacher", "REQUEST ACCESS FOR ANOTHER TEACHER", "requestAccess"],
  ["inviteTeacherToPlatform", "invite-teacher-to-platform", "INVITE A NEW TEACHER", "inviteTeacherToPlatform"],
  ["sendAccountSetupLink", "send-account-setup-link", "RESEND ACCOUNT SETUP LINK", "sendAccountSetupLink"],
  ["sendPasswordResetLink", "send-password-reset-link", "SEND PASSWORD RESET LINK", "sendPasswordResetLink"],
  ["updateUserEmail", "update-user-email", "UPDATE USER EMAIL", "updateUserEmail"],
  ["activateTeacherAccount", "activate-teacher-account", "ACTIVATE TEACHER ACCOUNT", "activateTeacherAccount"],
  ["resolveLoginIssue", "resolve-login-issue", "HELP A TEACHER LOG IN", "resolveLoginIssue"],
  ["renameUser", "rename-user", "UPDATE TEACHER NAME", "renameUser"],
  ["offerToAddTeacher", "offer-to-add-teacher", "OFFER TO ADD TEACHER", "offerToAddTeacher"],
  ["classroomTransition", "classroom-transition", "CLASSROOM TRANSITION", "classroomTransition"],
  ["requestInvoice", "request-invoice", "INVOICE QUERIES", "requestInvoice"],
  ["createClass", "create-class", "CREATE CLASS", "createClass"],
  ["removeClass", "remove-class", "REMOVE CLASS", "removeClass"],
  ["renameClass", "rename-class", "RENAME CLASS", "renameClass"],
  ["assignScreener", "assign-screener", "ASSIGN SCREENER", "assignScreener"],
  ["assignAlpacaLead", "assign-alpaca-lead", "ASSIGN OR CHANGE ALPACA LEAD", "assignAlpacaLead"],
  ["extendTrial", "extend-trial", "REQUEST TRIAL EXTENSION", "extendTrial"],
  ["mergeClasses", "merge-classes", "MERGE CLASSES", "mergeClasses"],
  ["removeTeacherAssignment", "remove-teacher-assignment", "REMOVE TEACHER FROM A CLASS", "removeTeacherAssignment"],
  ["requestEarlyPlatformAccess", "request-early-platform-access", "REQUEST SCREENING WINDOW ACCESS", "requestEarlyPlatformAccess"],
  ["trialAccessStatus", "trial-access-status", "TRIAL ACCESS HELP", "trialAccessStatus"],
  ["addChild", "add-child", "ADD CHILD", "addChild"],
  ["removeChild", "remove-child", "REMOVE CHILD", "removeChild"],
  ["fixDuplicateChild", "fix-duplicate-child", "FIX DUPLICATE CHILD", "fixDuplicateChild"],
  ["fixDuplicateResults", "fix-duplicate-results", "FIX DUPLICATE RESULTS", "fixDuplicateResults"],
  ["fixDuplicateChildResults", "fix-duplicate-child-results", "REPORT CHILD RESULTS ISSUE", "fixDuplicateChildResults"],
  ["restoreChildResults", "restore-child-results", "RESTORE CHILD RESULTS", "restoreChildResults"],
  ["swapStudentsResults", "swap-students-results", "SWAP STUDENTS’ RESULTS", "swapStudentsResults"],
  ["moveTransferChildren", "move-transfer-children", "MOVE CHILDREN BETWEEN CLASSES", "moveTransferChildren"],
  ["updateTeacherRoles", "update-teacher-roles", "UPDATE TEACHER ROLES", "updateTeacherRoles"],
  ["removeColleagueAccess", "remove-colleague-access", "REMOVE COLLEAGUE ACCESS", "removeColleagueAccess"],
  ["removeTeacherFromSchool", "remove-teacher-from-school", "REMOVE TEACHER FROM SCHOOL", "removeTeacherFromSchool"],
  ["sendWhatsappGroupInvite", "send-whatsapp-group-invite", "GET WHATSAPP INVITE", "sendWhatsappGroupInvite"],
  ["provideLoginBypass", "provide-login-bypass", "DOWNLOAD CHILD LOGIN LINKS", "provideLoginBypass"],
  ["makeResultsVisible", "make-results-visible", "REQUEST RESULTS ACCESS", "makeResultsVisible"],
  ["exportAssessmentData", "export-assessment-data", "ALADDIN EXPORT", "exportAssessmentData"],
  ["escalateTechnicalIssue", "escalate-technical-issue", "CONTACT SUPPORT", "escalateTechnicalIssue"],
  ["offerMeeting", "offer-meeting", "OFFER MEETING", "offerMeeting"],
  ["screeningGuidanceResources", "screening-guidance-resources", "SEARCH HELP AND GUIDANCE", "screeningGuidanceResources"],
  ["escalateFeatureRequest", "escalate-feature-request", "SUGGEST AN IMPROVEMENT", "escalateFeatureRequest"],
  ["resetTask", "reset-task", "RESET TASK", "resetTask"]
];

export const TEACHER_WORKFLOW_DEFINITIONS = Object.freeze(
  workflowDefinitions.map(([key, id, label, modal]) =>
    Object.freeze({ key, id, label, modal })
  )
);

export const TEACHER_WORKFLOWS = Object.freeze(
  Object.fromEntries(
    TEACHER_WORKFLOW_DEFINITIONS.map(({ key, id }) => [key, id])
  )
);

export const TEACHER_WORKFLOW_IDS = Object.freeze(
  TEACHER_WORKFLOW_DEFINITIONS.map(({ id }) => id)
);

export const TEACHER_WORKFLOW_GROUPS = Object.freeze([
  Object.freeze({
    id: "classes-and-class-access",
    label: "Manage Classes and Access",
    workflowIds: Object.freeze([
      TEACHER_WORKFLOWS.requestAccess,
      TEACHER_WORKFLOWS.requestAccessOtherTeacher,
      TEACHER_WORKFLOWS.classroomTransition,
      TEACHER_WORKFLOWS.createClass,
      TEACHER_WORKFLOWS.removeClass,
      TEACHER_WORKFLOWS.renameClass,
      TEACHER_WORKFLOWS.mergeClasses,
      TEACHER_WORKFLOWS.removeTeacherAssignment,
      TEACHER_WORKFLOWS.moveTransferChildren,
      TEACHER_WORKFLOWS.removeColleagueAccess
    ])
  }),
  Object.freeze({
    id: "teachers-and-accounts",
    label: "Teachers and Accounts",
    workflowIds: Object.freeze([
      TEACHER_WORKFLOWS.inviteTeacherToPlatform,
      TEACHER_WORKFLOWS.sendAccountSetupLink,
      TEACHER_WORKFLOWS.sendPasswordResetLink,
      TEACHER_WORKFLOWS.updateUserEmail,
      TEACHER_WORKFLOWS.activateTeacherAccount,
      TEACHER_WORKFLOWS.resolveLoginIssue,
      TEACHER_WORKFLOWS.renameUser,
      TEACHER_WORKFLOWS.offerToAddTeacher,
      TEACHER_WORKFLOWS.assignAlpacaLead,
      TEACHER_WORKFLOWS.updateTeacherRoles,
      TEACHER_WORKFLOWS.removeTeacherFromSchool,
      TEACHER_WORKFLOWS.sendWhatsappGroupInvite
    ])
  }),
  Object.freeze({
    id: "children-and-results",
    label: "Children and Results",
    workflowIds: Object.freeze([
      TEACHER_WORKFLOWS.addChild,
      TEACHER_WORKFLOWS.removeChild,
      TEACHER_WORKFLOWS.fixDuplicateChild,
      TEACHER_WORKFLOWS.fixDuplicateResults,
      TEACHER_WORKFLOWS.fixDuplicateChildResults,
      TEACHER_WORKFLOWS.restoreChildResults,
      TEACHER_WORKFLOWS.swapStudentsResults,
      TEACHER_WORKFLOWS.provideLoginBypass,
      TEACHER_WORKFLOWS.makeResultsVisible,
      TEACHER_WORKFLOWS.resetTask
    ])
  }),
  Object.freeze({
    id: "screening-trial-and-billing",
    label: "Screening, Trial and Billing",
    workflowIds: Object.freeze([
      TEACHER_WORKFLOWS.assignScreener,
      TEACHER_WORKFLOWS.requestEarlyPlatformAccess,
      TEACHER_WORKFLOWS.extendTrial,
      TEACHER_WORKFLOWS.trialAccessStatus,
      TEACHER_WORKFLOWS.requestInvoice,
      TEACHER_WORKFLOWS.exportAssessmentData
    ])
  }),
  Object.freeze({
    id: "help-and-support",
    label: "Help and Support",
    workflowIds: Object.freeze([
      TEACHER_WORKFLOWS.escalateTechnicalIssue,
      TEACHER_WORKFLOWS.offerMeeting,
      TEACHER_WORKFLOWS.screeningGuidanceResources,
      TEACHER_WORKFLOWS.escalateFeatureRequest
    ])
  })
]);
